export enum ScanStateAction {
    Scanning,
    Read,
    Processing,
    Complete,
}